import { render } from "./CatalogList.vue?vue&type=template&id=68f168f4"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__